// Node
import initDirectContracts from './show/direct_contacts';

const $ = require('jquery');

// Custom
import {
  cutCategoryTags,
  cutLongDescription,
  getRecentlyViewedApartments,
  saveProduct,
} from 'new_design/common/camps/show/utils';
import { campsSliderTnsInit, popupSliderTnsInit } from 'new_design/desktop/common/sliders';
import { uploadPreview, uploadVideos } from '../../common/camps/show/video';
import { setFavorites } from '../../common/favorite';
import { MTUIGetElement, MTUIOnInit } from '../../common/mtui/mtui';
import { fixBaseMenu, setNavElementEvents, setNavElementEventsWithFixHeader } from './show/nav';

require('new_design/common/camps/show/camp_questions');
require('new_design/common/camps/show/maps');
require('new_design/common/camps/show/reviews');
require('new_design/common/camps/show/fast_book_form');

document.addEventListener('user_is_checked', () => {
  if (window.user_present) $('.discounts_forbidden_label').show();
});

document.addEventListener('DOMContentLoaded', function () {
  uploadPreview();

  setNavElementEventsWithFixHeader(
    document.querySelectorAll('.page-nav .page-nav__list > .page-nav__list-item'),
    'page-nav__list-item_active',
    $('.page-nav')
  );

  setNavElementEvents(
    document.querySelectorAll('.popup-nav .popup-nav__list > .popup-nav__list-item'),
    'popup-nav__list-item_active'
  );

  setNavElementEventsWithFixHeader(
    document.querySelectorAll('.base-aside > .card__rating'),
    'card__rating_active',
    $('.page-nav')
  );

  fixBaseMenu();

  let tmpUrl = document.URL.split('/');
  let slugEndSymbol = tmpUrl[tmpUrl.length - 1].indexOf('?') !== -1 ? '?' : '#';
  let campSlug = tmpUrl[tmpUrl.length - 1].split(slugEndSymbol)[0];

  $('.service-description-truncated-open').click(function () {
    $(this).prev().removeClass('service-description-truncated');
    $(this).remove();
  });

  getRecentlyViewedApartments(campSlug);
  saveProduct(campSlug);
  cutLongDescription();
  cutCategoryTags();

  // Метрика кликов на оф. сайт
  $('.base-contact__list-item > a.before-ico_arrow').on('click', () => {
    window.ymReachGoal('camps_show_official_site_click');
  });

  $('.camp_full_address').on('click', () => {
    window.ymReachGoal('camp:address:map');
    window.mapOpenedFrom = 'Адрес в заголовке';
  });

  $('.camp_to_area_center_distance, .first_nearby_city, .second_nearby_city').on('click', () => {
    window.ymReachGoal('camp:nearby-cities:map');
    window.mapOpenedFrom = 'Ближайшие города';
  });

  $('#small_map').on('click', () => {
    window.ymReachGoal('camp:routes:map');
    window.mapOpenedFrom = 'Карта в описании';
  });

  $('#map_side, .base-contact__map-link').on('click', () => {
    window.ymReachGoal('camp:aside:map');
    window.mapOpenedFrom = 'Карта в сайдбаре';
  });

  $('.phone-click-log').on('click', function () {
    let phone = $(this).data('original');
    $(this).text(phone);
    window.ymReachGoal('show_phone_nomber');
    let source_text = $('h1').text().trim();
    let camp = window.camp;
    let source_url = window.location.href;
    let csrfToken = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
      url: '/phone_logs',
      type: 'POST',
      data: {
        phone: phone.trim(),
        camp_id: camp.id,
        source_text: source_text,
        source_url: source_url,
        authenticity_token: csrfToken,
      },
    });
  });

  fetch(`/camps/${camp.id}/direct_contacts`)
    .then((response) => {
      return response.text();
    })
    .then((data) => {
      if (data) {
        $('#direct_contacts').html(data).show();
        initDirectContracts();
      }
      // $('#direct_contacts').html(data).show();
      // initDirectContracts();
    })
    .catch((e) => {
      console.log(e);
    });

  $('.base-videos-btn').on('click', () => {
    uploadVideos();
    window.ymReachGoal('camp:video');
  });

  $('.faq').on('click', function () {
    let $this = $(this);
    let answerBlock = $this.find('.answer-block');
    let icon = $this.find('.question-block__icon');

    let iconBaseClass =
      icon.hasClass('mt-question-block__icon-add') || icon.hasClass('mt-question-block__icon-remove')
        ? 'mt-question-block__icon'
        : 'question-block__icon';

    if (answerBlock.hasClass('hidden')) {
      answerBlock.removeClass('hidden');
      icon.removeClass(iconBaseClass + '-add').addClass(iconBaseClass + '-remove');
    } else {
      answerBlock.addClass('hidden');
      icon.removeClass(iconBaseClass + '-remove').addClass(iconBaseClass + '-add');
    }
  });

  MTUIOnInit(() => {
    MTUIGetElement('certificate_amount')?.change((amount) => {
      $('#certificate_link').attr('href', `/certificates/new?amount=${amount}`);
    });
  });

  window.ymReachGoal('camps-show-metrika');

  popupSliderTnsInit();

  campsSliderTnsInit();

  setFavorites();
});
